import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, inputBorderColor, label, navigation, titles, urgentDate } from '../../../../styles/colors';

export const socialMediaSignatureStyleSheet = StyleSheet.create({
	characterCount: {
		color: navigation,
		fontSize: 12,
	},
	characterCountContainer: {
		marginTop: 4,
		textAlign: 'right',
	},
	characterCountError: {
		color: urgentDate,
		fontWeight: 'bold',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxWidth: 600,
	},
	description: {
		color: label,
		fontSize: 14,
		lineHeight: 1.4,
	},
	errorMessage: {
		color: urgentDate,
		fontSize: 12,
		marginTop: 4,
	},
	fieldGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		marginTop: 16,
	},
	buttonGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
		marginTop: 16,
	},
	cancelButton: {
		minWidth: 80,
	},
	checkbox: {
		color: titles,
		fontSize: 14,
	},
	checkboxContainer: {
		marginBottom: 8,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	label: {
		color: label,
		fontSize: 14,
		fontWeight: 'bold',
	},
	loadingContainer: {
		alignItems: 'center',
		color: label,
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: 20,
	},
	saveButton: {
		alignItems: 'center',
		display: 'flex',
		gap: 8,
		minWidth: 120,
	},
	textArea: {
		'& textarea': {
			border: `1px solid ${inputBorderColor}`,
			borderRadius: 4,
			fontFamily: 'inherit',
			fontSize: 14,
			minHeight: 120,
			padding: 16,
			resize: 'vertical',
		},
		'& textarea:focus': {
			borderColor: brandPrimaryText,
			outline: 'none',
		},
	},
});
